export enum DotLocation {
	Head = 1,
	HeadFront = 2,
	Body = 3,
	Legs = 4,
	BackLegs = 5,
	Belly = 6,
	Back = 7,
}

export interface Question {
	text: string;
	category: string;
	dotLocation: DotLocation;
}

export interface Session {
	questions: Array<Question>;
	sessionId: string;
	petType: 'dog' | 'cat' | 'other';
	petName: string;
}
